<div class="d-lg-none">
    <mlp-ng-button-nav
        side="left"
        (click)="previousImage()"
    ></mlp-ng-button-nav>
    <mlp-ng-button-nav side="right" (click)="nextImage()"></mlp-ng-button-nav>
</div>
